// extracted by mini-css-extract-plugin
export default {"buttons":"buttons_buttons__5Taqv","btns":"buttons_btns__H-cKq"};